export default (state: any, {isLoading}: any) => ({
  ...state,
  businessProfile: {
    ...state.businessProfile,
    isLoading,
  },
});
